import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";

/**
 *
 * @param {any[]} offerDetailedBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  offerDetailedBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalIncome = 0;
  const excelData = offerDetailedBalance.map((balance, index) => {
    totalIncome += isNaN(Number(balance.total)) ? 0 : Number(balance.total);
    return {
      order: index + 1,
      customer: balance.customer,
      employee: balance.employee,
      offers: (balance.sellDetails || [])
        .map((element) => {
          if (element.Offer) {
            return `${element.quantity} x ${
              element.Offer.name
            } s/${formatHelper.toMoney(element.total_net)})`;
          } else {
            return `${element.quantity} x Sin Servicio`;
          }
        })
        .join(", "),
      paymentType: balance.paymentMethod,
      totalPrice: formatHelper.toMoney(balance.total),
    };
  });

  excelData.push({
    order: "",
    customer: "TOTAL",
    employee: "",
    offers: "",
    paymentType: "",
    totalPrice: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR OFERTAS DETALLADO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "employee",
            outValue: "EMPLEADOS",
          },
          {
            inValue: "offers",
            outValue: "CONCEPTO",
          },
          {
            inValue: "paymentType",
            outValue: "FORMA DE PAGO",
          },
          {
            inValue: "totalPrice",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-detallado-por-ofertas_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-por-ofertas_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/OfferBalance/excel.js